import { render, staticRenderFns } from "./LearningCommunity.vue?vue&type=template&id=49ed0caa&scoped=true&"
import script from "./LearningCommunity.vue?vue&type=script&lang=js&"
export * from "./LearningCommunity.vue?vue&type=script&lang=js&"
import style0 from "./LearningCommunity.vue?vue&type=style&index=0&id=49ed0caa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ed0caa",
  null
  
)

export default component.exports